<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="mdi-format-list-checkbox"
    ></vuse-section-definition>
    <v-container fluid class="home-content rounded-lg">
      <v-tabs v-model="tabIndex">
        <v-tab v-for="item in items" :key="item.id">{{ item.tab }}</v-tab>
      </v-tabs>
    </v-container>
    <v-container fluid class="home-content rounded-lg">
      <v-row justify="center">
        <v-tabs-items v-model="tabIndex" class="min-width">
          <v-tab-item active class="">
            <gift-list></gift-list>
          </v-tab-item>
          <v-tab-item active class="">
            <gift-wrap></gift-wrap>
          </v-tab-item>
        </v-tabs-items>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import GiftList from "@/views/Pages/promotion_gift/gift/gift_list";
import GiftWrap from "@/views/Pages/promotion_gift/gift/gift_wrap";

export default {
  components: {
    GiftList,
    GiftWrap,
  },
  data() {
    return {
      tabIndex: 0,
      items: [
        { id: 0, tab: "Danh sách quà tặng" },
        { id: 1, tab: "Gói quà tặng" },
      ],
      page: "Quà tặng",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: false,
        },
        { text: "Khuyến mại/Quà tặng", disabled: false },
        { text: "Quà tặng", disabled: false },
      ],
    };
  },
  watch(){
  },
 async created(){
  //  this.tabIndex = this.$route.params.id
 },
  computed: {
    ...mapGetters(["isAuthenticated"]),
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }
  },
};
</script>
<style lang="scss">
.home-content {
  background: #ffffff !important;
}
.min-width {
  min-width: 90% !important;
}
</style>
